export default __webpack_public_path__ + "static/media/healthcare.cd8fa3b6.png";